<template>
  <van-popup class="popup" v-model="show" round position="bottom">
    <div class="popup-title">
      <span>处理报警</span>
    </div>
    <div class="popup-content">
      <div class="aj-form-item form-item-flex" style="align-items: center">
        <div class="aj-form-label">处理结果</div>
        <div class="aj-form-content">
          <div class="result-tag zhenshi" :class="{ active: handleType === 1 }" @click="handleType = 1">真 实</div>
          <div class="result-tag xunjian" :class="{ active: handleType === 2 }" @click="handleType = 2">巡 检</div>
          <div class="result-tag wubao" :class="{ active: handleType === 3 }" @click="handleType = 3">误 报</div>
        </div>
      </div>
      <div class="aj-form-item form-item-flex">
        <div class="aj-form-label">处理情况</div>
        <div class="aj-form-content"><textarea maxlength="100" v-model="reason" class="input-width-full" placeholder-style="color:#C4C4C4" placeholder="请填写" rows="5" /></div>
      </div>
      <div class="aj-form-item">
        <div class="aj-form-label" style="display: flex; align-items: flex-end">
          <div>处理照片</div>
          <div style="font-size: 0.56rem; color: #999; margin-left: 0.56rem">最多上传6张，单张图片不大于5M，禁止拍摄他人隐私照片</div>
        </div>
        <div class="aj-form-content photo-content">
          <div class="photo-box" v-for="(item, index) in photoList" :key="index">
            <div class="photo-item">
              <div class="photo-del" @click="delPhoto(index)">
                <img src="@/assets/del.svg" style="height: 1rem; width: 1rem" />
              </div>
              <img style="height: 100%; width: 100%; border-radius: 0.22rem" :src="item.tempFilePath" @click="predivImg(index)" />
            </div>
          </div>
          <div class="photo-box" v-if="photoList.length < 6">
            <van-uploader :after-read="afterRead" multiple :max-count="6 - photoList.length" :max-size="5 * 1024 * 1024" @oversize="onOversize" />
            <!-- <div class="photo-item" @click="chooseImg()" style="display: inline-flex; align-items: center; justify-content: center">
              <image class="image" src="/static/report/photo.png"></image>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="pop-bottom" style="display: flex; justify-content: space-around">
      <div class="bottom-button" @click.stop="cancel()">取 消</div>
      <div class="bottom-button button-primary" @click.stop="confirm()">确 定</div>
    </div>
  </van-popup>
</template>

<script>
import moment from 'moment';
import { ImagePreview } from 'vant';
import uploadImg2 from '@/utils/upload.service3';
import axios from 'axios';
import * as constant from '@/constant';
export default {
  props: {
    handlerId: {
      type: String,
      default: null
    },
    handlerName: {
      type: String,
      default: null
    },
    schoolId: {
      type: String,
      default: null
    },
    token: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      show: false,
      handleType: null,
      reason: '',
      photoList: [],
      ids: []
    };
  },

  methods: {
    onOversize() {
      this.$toast('部分图片不符合上传条件，请重新上传');
    },
    open(ids, handleType) {
      this.ids = ids;
      this.handleType = handleType;
      this.show = true;
    },
    cancel() {
      this.resetAll();
      this.show = false;
    },
    confirm() {
      let obj = {
        ids: this.ids,
        reason: this.reason,
        disposeImg: this.photoList,
        handleType: this.handleType,
        handlerId: this.handlerId,
        handlerName: this.handlerName,
        schoolId: this.schoolId,
        handleTime: moment().format('YYYY-MM-DD HH:mm:ss')
      };
      const loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });

      axios
        .post(constant.baseUrl + 'student-consumer/api/schoolBus/disposeWarningMini', obj, {
          headers: {
            Authorization: this.token
          }
        })
        .then(res => {
          loading.clear();
          if (res.data.data) {
            this.$toast(res.data.data);
          } else {
            this.$toast('处理成功');
          }
          setTimeout(() => {
            this.cancel();
            this.$emit('refresh');
          }, 1500);
        })
        .catch(e => {
          this.$toast('操作失败，请重试');
        });
    },
    resetAll() {
      this.photoList = [];
      this.reason = '';
      this.ids = [];
      this.handleType = null;
    },
    delPhoto(index) {
      this.photoList.splice(index, 1);
    },
    // 预览图片
    predivImg(index) {
      let tempList = this.photoList.map(item => {
        return item.tempFilePath;
      });
      ImagePreview({
        images: tempList,
        startPosition: index
      });
    },
    async afterRead(file) {
      console.log(typeof file);
      if (Array.isArray(file)) {
        file.forEach(async item => {
          this.upload(item);
        });
      } else {
        this.upload(file);
      }

      //   this.paramsList.photoImg = imgUrl;
    },
    async upload(file) {
      const res = await uploadImg2(file.file);
      this.photoList.push({
        tempFilePath: res
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.popup {
  font-size: 0.78rem;
}

.popup-title {
  padding: 1.1rem 0 0.8rem 0;
  text-align: center;
  font-size: 0.87rem;
  font-weight: bold;
}

.aj-form-item {
  padding: 1.22rem 0;
  font-size: 0.78rem;

  .required {
    color: #ff4747;
  }

  .aj-form-label {
    color: #1a1a1a;
  }
}

.aj-form-item.no-padding {
  padding: 0;
}

.aj-form-content {
  color: #666;

  textarea {
    border: none;
  }
}

.aj-form-item + .aj-form-item {
  border-top: 0.06rem solid #f4f4f6;
}

.form-item-flex {
  display: flex;
  justify-content: space-between;

  .aj-form-label {
    flex-shrink: 0;
    // line-height: 1.5;
    // line-height: 44rpx;
  }

  .aj-form-content {
    flex: 1;
    // line-height: 1.5;
    padding-left: 1.4rem;
  }
}

.align-center {
  align-items: center;
}

.input-width-full {
  width: 100%;
}

.input-width-full + .input-width-full {
  margin-top: 1.2rem;
}

.result-tag + .result-tag {
  margin-left: 0.67rem;
}

.result-tag {
  display: inline-block;
  border-radius: 0.22rem;
  font-size: 0.67rem;
  padding: 0.28rem 0.94rem;

  &.zhenshi {
    background-color: rgba($color: #f16f6d, $alpha: 0.15);
    color: #f16f6d;

    &.active {
      background: #f16f6d;
      color: #fff;
    }
  }

  &.xunjian {
    background-color: rgba($color: #fea301, $alpha: 0.15);
    color: #fea301;

    &.active {
      background: #fea301;
      color: #fff;
    }
  }

  &.wubao {
    background-color: rgba($color: #8f939e, $alpha: 0.15);
    color: #8f939e;

    &.active {
      background: #8f939e;
      color: #fff;
    }
  }
}

.photo-box {
  width: 33%;
  line-height: 1;

  .photo-item {
    position: relative;
    display: inline-block;
    width: 6.5rem;
    height: 6.5rem;
    background-color: #f1f2f6;
    border-radius: 0.22rem;

    img {
      object-fit: cover;
    }

    .photo-del {
      position: absolute;
      right: -0.5rem;
      top: -0.5rem;
    }
  }

  ::v-deep.van-uploader__upload {
    margin: 0;
    width: 6.5rem;
    height: 6.5rem;
  }
}

.photo-box:nth-of-type(3),
.photo-box:nth-of-type(6) {
  text-align: right;
}

.photo-box:nth-of-type(2),
.photo-box:nth-of-type(5) {
  text-align: center;
}

.photo-content {
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 0;
}

.bottom-button {
  background-color: #f1f2f6;
  display: inline-block;
  border-radius: 0.22rem;
  font-size: 0.78rem;
  padding: 0.72rem 0;
  flex: 1;
  text-align: center;
  margin: 0 0.5rem;
}

.button-disabled {
  opacity: 0.5;
}

.button-primary {
  background-color: #0065e1;
  color: #fff;
}

.button-warning {
  background-color: #fea301;
  color: #fff;
}

.button-danger {
  background-color: #f16f6d;
  color: #fff;
}

.button-info {
  background-color: #8f939e;
  color: #fff;
}

.pop-bottom {
  padding: 0.83rem 0;
}
</style>
